import { Component } from '@angular/core';
import { AuthService, DashboardConfiguration, PermissionsEnum } from 'shared-lib';

@Component({
  selector: 'app-map-layout',
  templateUrl: './map-layout.component.html',
  styleUrl: './map-layout.component.scss',
  standalone: false
})
export class MapLayoutComponent {
  isSidebarExpanded: boolean = false;
  PermissionsEnum = PermissionsEnum;
  DashboardConfiguration = DashboardConfiguration;

  constructor(public authService: AuthService) {}

  onMouseEnter() {
    this.isSidebarExpanded = true;
  }

  onMouseLeave() {
    this.isSidebarExpanded = false;
  }
}
